import fuzzysort, { KeysResults } from 'fuzzysort';

export type KeysOfUnion<T> = T extends T ? keyof T : never;

export function emptyFuzzySortOnKeys<T>() {
    return fuzzysort.go<T>('', [], { keys: [] });
}

export function executeFuzzySortOnKeys<T>(
    filterText: string,
    elements: Array<T>,
    fuzzySearchKeys: Array<KeysOfUnion<T>>,
    limit: number = Infinity
): KeysResults<T> {
    return fuzzysort.go<T>(filterText, elements, {
        keys: fuzzySearchKeys as string[],
        limit: limit,
        threshold: 0
    });
}
